import { GET_ORDER_TOTALS } from '../actionTypes/CartActionTypes';

export const getOrderTotals = (payload) => ({
    type: GET_ORDER_TOTALS,
    payload,
});

export default { getOrderTotals };
